import { apiPost } from 'utils/request';
import HOST from 'utils/globals';

export const acceptInvite = body => apiPost(`${HOST}/invitation/accept`, body);
